module.exports = __webpack_public_path__ + "img/Camera&lens5.d7f8d19b.png";